import { render, staticRenderFns } from "./FeaturedPackage.vue?vue&type=template&id=95f8d658&"
import script from "./FeaturedPackage.vue?vue&type=script&lang=js&"
export * from "./FeaturedPackage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports